<div class="modal-content p-4">


  <div class="modal-body p-0">
    <form (ngSubmit)="onSubmit(dialogRef)">
      <div class="mb-4">
        <label for="password" class="form-label mb-3 fs-6 text-dark">
          Please enter your password to access the menu
        </label>
        <div class="input-group">
          <input
            [type]="passwordVisible ? 'text' : 'password'"
            class="form-control border-end-0 text-dark custom-input"
            id="password"
            [(ngModel)]="password"
            name="password"
            required
            placeholder="Enter password"
          />
          <button class="btn custom-eye-button border-start-0" type="button" (click)="togglePasswordVisibility()">
            <i class="bi" [class.bi-eye-slash]="passwordVisible" [class.bi-eye]="!passwordVisible"></i>
          </button>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2">
        <button type="button"           class="btn btn-warning fw-bold px-4 py-2 rounded-pill shadow-lg"
        (click)="dialogRef.close()">
          Cancel
        </button>
        <button type="submit"           class="btn btn-warning fw-bold px-4 py-2 rounded-pill shadow-lg"
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</div>
  